<!--
 * @Author: Colin 陈广玖
 * @Date: 2023-08-03 15:43:11
 * @Descripttion: 
-->
<template>
  <div id="app">
    <div class="title">
      <img src="./assets/Type=4C, Claim=No@3x.png" class="logo"/>
    </div>
    <div class="center">
      <div
        class="projectBox"
        v-for="item in columns"
        :key="item.id"
        @click="gotoProject(item)"
        >
        <div class="imgBox">
            <img :src="item.img" :style="{height: item.heigh+'px',width: item.width+'px'}"/>
        </div>
        <div class="name">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      columns: [
        {
          id:1,
          title: '卡赫洗车机综合管理平台',
          width:380,
          url:'scw/#/',
          type:1,
          img: require('./assets/project/v2-12877617a335189356d1d2bfe8f75242_b.gif')
        },
        {
          id:2,
          title: '卡赫洗车机客户运营平台',
          width:380,
          url:'scwc/home',
          type:1,
          img: require('./assets/project/78de7b8939865d6d08d2462924573453.jpeg')
        },
        {
          id:3,
          title: '卡赫智慧生活平台',
          width:360,
          url:'ksl/#/',
          type:1,
          img: require('./assets/project/56BFD03B-C7EC-444a-9FD3-FDA40FCE7FE8.png')
        },
        {
          id:4,
          title: '卡赫洗地机综合管理平台',
          url:'fcw/#/',
          heigh:200,
          width:360,
          type:1,
          img: require('./assets/project/20230721163418_ibz9.jpg')
        },
        {
          id:5,
          title: '卡赫洗地机客户运营平台',
          width:380,
          type:1,
          url:'fcwc/#/',
          img: require('./assets/project/unnamed.jpg')
        },
        {
          id:6,
          title: '卡赫商用净水平台',
          width:380,
          url:'pwp/#/',
          type:1,
          img: require('./assets/project/ae1daef9c9512910d2c0001a1277fd7d.jpeg')
        },
        // {
        //   id:7,
        //   title: '项目综合管理平台(禅道)',
        //   width:380,
        //   type:2,
        //   img: require('./assets/project/unnamed.jpg')
        // },
      ]
    };
  },
  methods:{
    gotoProject(e){
      let url = ''
      if(e.type === 1){
        if (window.location && (
          window.location.host.indexOf('iot.kahechina.com') > -1 && 
          window.location.host.indexOf('testiot.kahechina.com') < 0
          )) {
          url = 'https://iot.kahechina.com/'+e.url
        } else {
          url = 'https://testiot.kahechina.com/'+e.url
        }
      }else if(e.type === 2){
        url = 'http://vpn.kahechina.com:9080/zentao/user-login.html'
      }else{
        url = 'http://mqtt.kahechina.com:18083/'
      }
      window.open(url)
    }
  }
}
</script>

<style>
  html{
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('./assets/20221207211525_cm1m.jpg');
  }
  body{
    height: 100%;
    overflow: hidden;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.1);
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
  }
  .logo{
    width: 200px;
  }
  .center{
    width: 1200px;
    margin: 0 auto 60px;
    display: flex;
    flex-wrap: wrap;  
    justify-content:  space-between
  }
  .projectBox{
    cursor: pointer;
    width: 360px;
    border-radius: 10px;
    margin-bottom: 30px;
    margin-right: 40px;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow:2px 2px 3px 3px rgba(0, 0, 0, 0.03);
    opacity: 1;
  }
  .imgBox{
    height: 200px;
    overflow: hidden;
    background-color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .name{
    font-size: 16px;
    padding: 10px 20px;
    font-weight: 600;
    color: #000;
    background-color:#c7c6b8;
    box-sizing: border-box;
  }
</style>
